import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconWebAudit(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fillRule="evenodd" fill="currentColor" clipRule="evenodd">
        <path d="m9 25c2.209139 0 4-1.790861 4-4s-1.790861-4-4-4-4 1.790861-4 4 1.790861 4 4 4zm0 1c-2.76142375 0-5-2.2385763-5-5s2.23857625-5 5-5c2.7614237 0 5 2.2385763 5 5s-2.2385763 5-5 5z" />
        <path d="m23 25c2.209139 0 4-1.790861 4-4s-1.790861-4-4-4-4 1.790861-4 4 1.790861 4 4 4zm0 1c-2.7614237 0-5-2.2385763-5-5s2.2385763-5 5-5 5 2.2385763 5 5-2.2385763 5-5 5z" />
      </g>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
      >
        <path d="m6.5 17.5v-8.89361702c1-1.87234043 2.33333333-2.4964539 4-1.87234043" />
        <path
          d="m21.5 17.5v-9c1-1.80141844 2.3333333-2.39007092 4-1.76595745"
          transform="matrix(-1 0 0 1 47 0)"
        />
        <path d="m12 17.5c1.9303379-1.6666667 3.2636712-2.5 4-2.5 2.6669271 0 4 2.5 4 2.5" />
      </g>
    </Icon>
  )
}
